import { useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { resolveAuthLang } from "utils/authLanguage";

/** Prefer URL :lang, then ?lang=, then i18n, then stored default (always en or nl). */
const useAuthLang = () => {
  const { lang: langFromUrl } = useParams();
  const [searchParams] = useSearchParams();
  const { i18n } = useTranslation();
  return resolveAuthLang({
    langParam: langFromUrl,
    search: searchParams.toString() ? `?${searchParams.toString()}` : "",
    i18nLang: i18n.language,
  });
};

export default useAuthLang;
